import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { InfoBoxComponent } from './info-box/info-box.component';
import { NavComponent } from './nav/nav.component';
import { SearchComponent } from './search/search.component';

@Component({
  selector: 'app-landing',
  imports: [
    CommonModule,
    InfoBoxComponent,
    NavComponent,
    SearchComponent,
    RouterModule,
  ],
  templateUrl: './landing.component.html',
  styleUrls: ['./landing.component.scss'],
})
export class LandingComponent implements OnInit {
  public imageUrls: string[] = [
    '../../assets/images/familyBeachDark.jpg',
    '../../assets/images/family_park_dark.jpg',
    '../../assets/images/father_son_dark.jpg',
    '../../assets/images/mother_daughter_dark.jpg',
  ];

  public backgroundImage = '';

  ngOnInit(): void {
    const rand = Math.round((Math.random() * 100) % 3);
    this.backgroundImage = this.imageUrls[rand];
  }
}
